import { render } from "./discount.vue?vue&type=template&id=2a5ec1a0&scoped=true"
import script from "./discount.vue?vue&type=script&lang=js"
export * from "./discount.vue?vue&type=script&lang=js"

import "./discount.vue?vue&type=style&index=0&id=2a5ec1a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a5ec1a0"

export default script